/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_CtaInputs */

const et_hero_cta = /** @type {(inputs: Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broneeri tasuta 15-min konsultatsioon`)
};

const en_hero_cta = /** @type {(inputs: Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a free 15-min consultation`)
};

/**
* | output |
* | --- |
* | "Book a free 15-min consultation" |
*
* @param {Hero_CtaInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_cta = /** @type {((inputs?: Hero_CtaInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_CtaInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_cta(inputs)
	return en_hero_cta(inputs)
});